import React from "react";
import { inject } from "mobx-react";
import { Icon } from "best-common-react";

class DeleteContactPencilFormatter extends React.Component {
  render() {
    const { contactManagementStore } = this.props.rootStore;
    return (
      <div id="edit-contact-formatter">
        <Icon
          iconName="fa-trash-alt"
          onClick={() => {
            contactManagementStore.setSelectedContact(this.props.value);
            contactManagementStore.setShowDeleteContactModal(true);
          }}
        />
      </div>
    );
  }
}

export default inject("rootStore")(DeleteContactPencilFormatter);
